import { useSelector } from 'react-redux';
import { useFetchActiveOffersQuery } from 'services/api/offer-auction';
import { useGetSalesHistoryQuery } from 'services/api/sales';

export const useSalesHistoryOfferAuction = (vehicleId: number) => {
  const { page, perPage, filters } = useSelector((state: any) => state.salesHistory);
  const { data: vehicles } = useGetSalesHistoryQuery({
    limit: perPage,
    offset: page,
    ...filters
  });

  const vehicleIds = (vehicles?.rows?.ids as number[]) ?? [];

  const { data: offerAuctions } = useFetchActiveOffersQuery(
    { vehicleIds },
    {
      skip: vehicleIds.length === 0
    }
  );

  const offerAuction = offerAuctions?.entities?.[vehicleId] ?? null;
  return offerAuction;
};
